import React, { useState, useEffect } from "react";
import { getobj, postobj } from "../apicall/apicall";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { TableRow, Button, Box } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../style/style";
import TableHead from "@mui/material/TableHead";
import Pagination from "@mui/material/Pagination";
import LoadingButton from "@mui/lab/LoadingButton";
import GetAppIcon from "@mui/icons-material/GetApp";

export default function MonthlyBillingStat(props) {
  const [loader, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [devices, setDevices] = useState([]);
  const [totalpage, setpaget] = useState();
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    // Validate props before making request
    if (
      !props.customerId ||
      !props.data ||
      !props.data["date"] ||
      !props.data["date"]["from_utc"]
    ) {
      console.warn("Missing required props for bill-stat request");
      console.warn("Props structure:", {
        customerId: props.customerId,
        data: props.data,
        date: props.data?.["date"],
        from_utc: props.data?.["date"]?.["from_utc"],
      });
      setloaded(false);
      return;
    }

    setloaded(true);

    // Debug: Log the raw from_utc value
    const startDateValue = props.data["date"]["from_utc"];
    console.log(
      "Start date value:",
      startDateValue,
      "Type:",
      typeof startDateValue,
    );

    // Ensure start_date is a string and not empty
    const params = new URLSearchParams({
      page: String(page),
      device_group: String(props.data["data"] || "bluetooth"),
      start_date: String(startDateValue).trim(), // ✅ Convert to string and trim
      bill_type: String(props.data["bill_type"] || "monthly"),
    });

    const url = `${process.env.REACT_APP_ZEWA_URL}user/bill-stat/${props.customerId}/?${params.toString()}`;

    getobj(url)
      .then((response) => {
        // Validate response structure
        console.log("Bill stat response:", response);

        if (!response || !response.results) {
          // console.error("Invalid response structure:", response);
          setDevices([]);
          setpaget(0);
          setloaded(false);
          return;
        }

        // Safe pagination calculation
        const totalCount = response.count || 0;
        const calculatedPages = totalCount > 0 ? Math.ceil(totalCount / 5) : 0;

        setpaget(calculatedPages);
        setDevices(response.results || []);
        setloaded(false);
      })
      .catch((error) => {
        // Better error reporting
        console.error("Error fetching bill stat:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
          url: url,
        });
        setDevices([]);
        setpaget(0);
        setloaded(false);
      });
  }, [page, props.customerId, props.data]);

  const handlePagechange = (event, value) => {
    setpage(value);
  };

  const handleExport = () => {
    setIsExporting(true);
    const url = `${process.env.REACT_APP_ZEWA_URL}user/download-csv/`;
    const data = {
      bill_id: props.data.id,
      customer_id: props.customerId,
      device_group: props.data["data"],
      start_date: props.data["date"]["from_utc"],
      bill_type: "monthly",
    };

    postobj(url, data)
      .then((response) => {
        const csvContent = response.map((row) => row.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });
        const urlBlob = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urlBlob;
        const dateObj = new Date(props.data["date"]["from_utc"]);
        link.download = `Monthly_BillingStatement_${dateObj.toLocaleString(
          "en-us",
          {
            month: "short",
            year: "numeric",
          },
        )}_${props.data["data"]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsExporting(false);
      })
      .catch((error) => {
        console.error("Error exporting CSV:", error);
        setIsExporting(false);
      });
  };

  return (
    <div>
      {loader ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <>
          {/*
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <LoadingButton
              size="small"
              onClick={handleExport}
              endIcon={<GetAppIcon />}
              loading={isExporting}
              loadingPosition="end"
              variant="contained"
              color="primary"
            >
              <span>Export</span>
            </LoadingButton>
          </Box>
          */}
          {devices && devices.length > 0 ? (
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    {props.data["data"] === "hub" ? (
                      <StyledTableCell>
                        <b>Hub Id</b>
                      </StyledTableCell>
                    ) : (
                      <>
                        <StyledTableCell>
                          <b>Device Group</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Model</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>Bluetooth ID</b>
                        </StyledTableCell>
                        <StyledTableCell>
                          <b>IMEI</b>
                        </StyledTableCell>
                      </>
                    )}
                    <StyledTableCell>
                      <b>Device Status</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Provisioned Date</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Activation Date</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Free Period</b>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {devices.map((device) => (
                    <StyledTableRow key={device.id}>
                      {props.data["data"] === "hub" ? (
                        <StyledTableCell>
                          {device.hub_id || "-"}
                        </StyledTableCell>
                      ) : (
                        <>
                          <StyledTableCell>{device.group}</StyledTableCell>
                          <StyledTableCell>{device.model}</StyledTableCell>
                          <StyledTableCell>
                            {device.mac_address}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.imei_number}
                          </StyledTableCell>
                        </>
                      )}
                      <StyledTableCell>
                        {device.active_status ? "Active" : "Inactive"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {new Date(device.created_at)
                          .toLocaleString("en-us", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            timeZone: "UTC",
                          })
                          .replace(/,/g, " ")}
                      </StyledTableCell>
                      <StyledTableCell>
                        {new Date(device.activation_date)
                          .toLocaleString("en-us", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            timeZone: "UTC",
                          })
                          .replace(/,/g, " ")}
                      </StyledTableCell>
                      <StyledTableCell>
                        {device.free_period?.free_time_period ||
                          device.free_period_detail?.free_time_period ||
                          "-"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <Pagination
                count={totalpage}
                page={page}
                variant="outlined"
                color="primary"
                onChange={handlePagechange}
              />
            </TableContainer>
          ) : (
            <p style={{ textAlign: "center", padding: "20px", color: "#666" }}>
              No devices found for this period.
            </p>
          )}
        </>
      )}
    </div>
  );
}
